<template>
  <div style="height: 100%">
    <!--    <div class="topTitle">-->
    <!--        <van-icon name="arrow-left" class="topTitle-icon" v-if="topBackIconShow" @click="goBack"/>-->
    <!--        <div :span="22">{{topTitle}}</div>-->
    <!--    </div>-->
    <router-view style="height: calc(100% - 70px)"/>
    <nut-tabbar
      :tabbarList="tabList"
      :bottom="true"
      @tab-switch="tabSwitch3"
    >
    </nut-tabbar>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'NavBottom',
    data() {
      return {
        tabList: [
          {
            'tabTitle': '终端',
            'curr': false,
            'icon': '/static/images/terminal.png',
            'activeIcon': 'static/images/activate-terminal.png',
            'href': '#/terminal',
          },
          {
            'tabTitle': '节目',
            'curr': false,
            'icon': '/static/images/program.png',
            'activeIcon': '/static/images/activate-program.png',
            'href': '#/programs',
          },
          {
            'tabTitle': '素材',
            'curr': false,
            'icon': '/static/images/material.png',
            'activeIcon': '/static/images/activate-material.png',
            'href': '#/material',
          },
          {
            'tabTitle': '我的',
            'curr': false,
            'icon': '/static/images/my.png',
            'activeIcon': '/static/images/activate-my.png',
            'href': '#/my',
          },
        ]
      }
    },
    computed: {
      ...mapState({
        topTitle: state => state.topTitle,
        topBackIconShow: state => state.topBackIconShow,
        parentPage: state => state.parentPage
      })
    },
    mounted() {
      let url = window.location.hash
      for (let i = 0; i < this.tabList.length; i++) {
        if (url === this.tabList[i].href) {
          this.tabList[i].curr = true
        }
      }
    },
    methods: {
      ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
      tabSwitch3: function (value) {
        // this.topTitle = value.tabTitle
        this.changeTopTitle(value.tabTitle)
        this.changeTopIconStatus(false)
      },
      goBack() {
        this.$router.push({path: this.parentPage})
        if (this.parentPage == 'taskdetail') {
          this.changeTopTitle('任务详情')
          this.setParentPage('programs')
        } else if (this.parentPage == 'programs') {
          this.changeTopTitle('节目')
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'my') {
          this.changeTopTitle('我的')
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'programs') {
          this.changeTopTitle('节目')
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'terminal') {
          this.changeTopTitle('终端')
          this.changeTopIconStatus(false)
        }
      }
    },
  }
</script>

<style lang="scss">
  .topTitle {
    height: 40px;
    background: #1B89FA;
    line-height: 40px;
    color: #fff;
    position: relative;
    text-align: center;

    .topTitle-icon {
      position: absolute;
      left: 10px;
      top: 10px;
      font-size: 25px;
    }
  }

  .nut-dialog-ok {
    background: #fff;
    border-top: 1px solid #F6F6F6;
    color: #1B89FA;
  }

  .nut-dialog-title {
    font-weight: 600;
    color: #333 !important;
    text-align: left !important;

  }

  .nut-dialog-footer {
    justify-content: flex-end;
    border: none;
    height: 55px;
  }

  .nut-dialog-btn {
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    width: 60px;
    flex: none;
    margin-left: 10px;
    border-radius: 5px;
  }

  .nut-dialog-cancel {
    border: 1px solid #e41f19;
    color: #e41f19;
  }

  .nut-dialog-cancel:active {
    background: #fff;
    border: 1px solid #e41f19;
  }

  .nut-dialog-ok {
    border: 1px solid #1B89FA;
    color: #fff;
    background: #1B89FA;
    margin-right: 20px;
  }

  .nut-dialog-ok:active {
    background: #1B89FA;
  }

  .van-dialog__header {
    text-align: left !important;
    text-indent: 20px;
    font-weight: 600;
  }

  .van-dialog__content {
    padding: 0 20px;
  }



  .van-picker {
    .van-picker__toolbar {
      border-bottom: 1px solid #ddd;
      color: #333;

      .van-picker__cancel {
        color: #ee0a24;
      }
    }
  }
</style>
